export const DOWNLOAD_PUBLICATION_BASEURL = "/download/publication/";
